import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DictionaryComponent } from 'src/app/pages/dictionary/dictionary.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

const routes: Routes = [
  {
    path: '',
    component: DictionaryComponent,
    canActivate: [AuthenticationService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DictionaryRoutingModule { }
